/**
 * Web entrypoint: there is no OS health store in the browser, so the connect
 * affordance is hidden and everything keeps working. Same no-op as the base.
 */
export { unavailableHealthProvider as healthProvider } from './unavailable-health-provider';
export * from './health-provider.types';
